import { EditBase } from "../shared/edit.base";
import { Component, Inject } from "@angular/core";
import { ActivityTypeDataService } from "../../core/activitytypes.dataservice";
import { StateService, TransitionService } from "@uirouter/angular";
import { MatDialog } from "@angular/material/dialog";

@Component({
    selector: "crew-edit-activitytype",
    template: require('./activitytype.edit.component.html')
})
export class EditActivityType extends EditBase<Nema.Crew.Model.ActivityType> {

    constructor(
        stateService: StateService,
        transitionService: TransitionService,
        dialog: MatDialog,
        @Inject('activityType') entity: Nema.Crew.Model.ActivityType,
        @Inject(ActivityTypeDataService.Id) activityTypeDataService: ActivityTypeDataService,
        @Inject('$log') $log: ng.ILogService,
        @Inject('isNew') isNew: boolean) {

        super(stateService, transitionService, dialog, entity, activityTypeDataService, $log, isNew);
    }

    public entityDisplayName = "Activity";

    public listStateName = "app.settings.activitytypes";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/activitytypes/activitytype.edit.component.ts